interface FolderSharingState {
  isShared?: boolean;
}

export function hasSharedSourceFolder(
  sourceFolderIds: string[],
  folderTreeHash?: Record<string, FolderSharingState | undefined>,
): boolean {
  return sourceFolderIds.some(
    (sourceFolderId) => folderTreeHash?.[sourceFolderId]?.isShared === true,
  );
}

export function shouldHidePrivateFoldersForMove(
  sourceFolderIds: string[],
  folderTreeHash?: Record<string, FolderSharingState | undefined>,
): boolean {
  if (sourceFolderIds.length === 0) {
    return false;
  }

  // Subfolders cannot be directly shared from the UI, so checking each
  // selected source folder's own shared status is sufficient.
  return hasSharedSourceFolder(sourceFolderIds, folderTreeHash);
}
